<template>
  <v-container fluid>

    <v-row>
      <v-col>
        <v-card :loading="loading" elevation="24">
          <v-card-title>RustBox.eu Leaderboard</v-card-title>

          <v-tabs v-model="activeServer">
            <v-tab v-for="server in servers" :key="server">
              {{ server }}
            </v-tab>
          </v-tabs>
          <v-divider/>

          <leaderboard-table v-if="leaderboard.length > 0" :leaderboard="leaderboard"/>

          <v-card-text v-if="leaderboard.length === 0">
            <v-alert type="info" elevation="2">
              Hey! There were no players since the last wipe on this Server. Or the Leaderboard was not calculated
              yet.
            </v-alert>
          </v-card-text>

          <v-card-actions class="pb-0 mb-0">
            <v-select :items="wipes" v-model="wipeId" placeholder="Current Wipe" outlined dense
                      class="pb-0 mb-0"></v-select>
          </v-card-actions>

          <!--
          <v-divider/>
          <v-card-text>
            <div>
              <iframe scrolling="no" frameborder="0"
                      style="border:0; width: 100%; height: 95%; min-height: 410px; margin:0; padding:0;"
                      src="https://rust-servers.info/widget_serverv2.php?server_id=4961"></iframe>
            </div>
          </v-card-text>
          -->
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<style scoped>

</style>

<script>
import axios from 'axios';
import moment from 'moment';
import LeaderboardTable from "@/components/LeaderboardTable";

export default {
  name: 'Home',
  computed: {},
  data: () => ({
    servers: [],
    activeServer: null,

    leaderboard: [],
    loading: false,

    wipeId: null,
    wipes: [],


  }),
  methods: {
    fetchWipes(serverIdentity) {
      axios.get('/api/server/' + encodeURIComponent(serverIdentity) + '/wipes').then(r => {
        this.wipes = [];

        r.data.forEach(item => {
          if (item.endedAt) {
            let start = moment(item.startedAt);
            let end = moment(item.endedAt);

            this.wipes.push({
              text: "Wipe " + start.format('DD.MM.YYYY') + " to " + end.format('DD.MM.YYYY') + " (" + item.id + ")",
              value: item.id,
            })
          }
        })

        this.wipes.push({
          text: 'Current Wipe', value: null,
        });
      })
    },
    fetchServers() {
      axios.get('/api/servers').then(r => {
        this.servers = [];

        r.data.forEach(row => {
          this.servers.push(row.name)
        })

        if (this.$route.params.serverName) {
          this.activeServer = this.$route.params.serverName;
        } else {
          this.activeServer = this.servers.length > 0 ? this.servers[0] : null;
        }
      })
    },
    fetchLeaderboard(serverIdentity) {
      if (!serverIdentity) return;

      this.loading = true;

      let url = '/api/server/' + encodeURIComponent(serverIdentity) + '/leaderboard';
      if (this.wipeId) {
        url = '/api/wipe/' + this.wipeId + '/leaderboard';
      }

      axios.get(url).then(r => {
        this.leaderboard = r.data;
        this.leaderboard.sort((a, b) => a.points - b.points).reverse();

        for (let i = 0; i < this.leaderboard.length; i++) {
          this.leaderboard[i].rank = i + 1;

          this.leaderboard[i].damageDealtToPlayers = Math.round(this.leaderboard[i].damageDealtToPlayers);
          this.leaderboard[i].damageDealt = Math.round(this.leaderboard[i].damageDealt);
          this.leaderboard[i].damageReceivedFromPlayers = Math.round(this.leaderboard[i].damageReceivedFromPlayers);
          this.leaderboard[i].damageReceivedFromEnvironment = Math.round(this.leaderboard[i].damageReceivedFromEnvironment);
          this.leaderboard[i].longestDistanceShot = Math.round(this.leaderboard[i].longestDistanceShot);
          this.leaderboard[i].longestDistanceShotPve = Math.round(this.leaderboard[i].longestDistanceShotPve);

          this.leaderboard[i].gatheredTotal = this.leaderboard[i].gatheredWood + this.leaderboard[i].gatheredStone + this.leaderboard[i].gatheredMetalOre + this.leaderboard[i].gatheredHighQualityMetalOre + this.leaderboard[i].gatheredSulfurOre + this.leaderboard[i].gatheredCloth;
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    if (this.$route.params.wipeId) {
      this.wipeId = this.$route.params.wipeId;
    }

    this.fetchServers();
  },
  components: {LeaderboardTable},
  watch: {
    activeServer: function (newVal) {
      this.fetchLeaderboard(this.servers[newVal]);
      this.fetchWipes(this.servers[newVal]);
    },
    wipeId: function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.fetchLeaderboard(this.servers[this.activeServer])
      }
    }
  }
}
</script>
